<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="title"
                      />

                      <form-error :model="$v.title" :dirty="$v.$dirty" label="Naziv"/>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.description.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea class="form-control form-control-modern" v-model="description"></textarea>

                      <form-error :model="$v.description" :dirty="$v.$dirty" label="Opis"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="image"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <!--
                        <span class="form-text">
                          Učitajte sliku rezolucije 200px x 60px
                        </span>
                      -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" v-if="imageUrl">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div
                          class="img-fluid"
                        >
                          <img
                            class="img-thumbnail"
                            :src="imageUrl"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

        </div>
      </div>


      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'InterestsAreas' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddInterestsArea',
  mixins: [translations],
  validations,
  components: { FormError },
  data() {
    return {
      title: '',
      description: '',
      imageUrl: '',
      image: {
        fileName: '',
        file: '',
      }
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  methods: {
    handlePhotoUpload() {
      const file = this.$refs.image.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.image.file = e.target.result.split(',')[1];
        this.image.fileName = file.name;
      };
    },
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { title, description, image } = this;

      api.createInterestsArea({ title, description, image }).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'InterestsAreas' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
};
</script>